import CtaBand from "../components/CtaBand";
import ContactSection from "../components/ContactSection";
import ForVenues from "../components/ForVenues";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import WhyBarmaid from "../components/WhyBarmaid";
import { useDocumentTitle } from "../i18n";

export default function LandingPage() {
  useDocumentTitle();

  return (
    <>
      <Hero />
      <HowItWorks />
      <ForVenues />
      <WhyBarmaid />
      <ContactSection />
      <CtaBand />
    </>
  );
}
